/**
 * @func isNumericalString
 * @param value - the input of the function
 * @return {boolean}
 * @desc Checks that the input is an numerical string
 *```js
 * isNumericalString('9');
 * // returns true
 *
 * isNumericalString('9agsdh');
 * //returns false
 *
 * isNumericalString(9);
 * //returns false
 *```
 * @memberof module:TypeCheck
 * @instance
 */
function isNumericalString(value) {
    if (typeof value === 'string' && !!Number(value))
        return true;
    if (value === '0')
        return true;
    return false;
}

export { isNumericalString as default };
